import React from 'react';

export const moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const SITUACOES = {
  conciliado: { rotulo: 'Conciliado', classe: 'ok' },
  pago_a_maior: { rotulo: 'Pago a maior', classe: 'warn' },
  pago_a_menor: { rotulo: 'Pago a menor', classe: 'crit' },
  sem_pagamento: { rotulo: 'Sem pagamento', classe: 'neutral' }
};

export function SituacaoBadge({ situacao }) {
  const { rotulo, classe } = SITUACOES[situacao] || SITUACOES.sem_pagamento;
  return <span className={`pay-status pay-status-${classe}`}>{rotulo}</span>;
}

export function FormasResumo({ pedido }) {
  const formas = [...new Set(pedido.pagamentos.map(pagamento => pagamento.forma))];
  if (!formas.length) return <span className="pay-empty">Não informado</span>;
  return <span className="pay-chips">{formas.map(forma => <span className="pay-chip" key={forma}>{forma}</span>)}</span>;
}

// Só existem no JSON os campos que a maquininha preencheu; o que veio vazio não é exibido.
const dadosDoPagamento = pagamento => [
  ['NSU', pagamento.nsu],
  ['NSU PIX', pagamento.nsu_pix],
  ['Bandeira', pagamento.bandeira || pagamento.mp_bandeira],
  ['Rede', pagamento.rede],
  ['Adquirente', pagamento.adquirente],
  ['CNPJ da adquirente', pagamento.cnpj_adquirente],
  ['ID Mercado Pago', pagamento.mp_id_pagamento],
  ['ID do estorno', pagamento.mp_id_estorno],
  ['Taxa', pagamento.mp_taxa > 0 ? moeda.format(pagamento.mp_taxa) : null]
].filter(([, valor]) => valor);

function CartaoPagamento({ pagamento }) {
  const dados = dadosDoPagamento(pagamento);
  return (
    <article className="pay-card">
      <header>
        <div>
          <strong>{pagamento.forma}</strong>
          <small>{pagamento.data_pagamento || 'Data não informada'}{pagamento.parcelas > 1 ? ` · ${pagamento.parcelas} parcelas` : ''}</small>
        </div>
        <b>{moeda.format(pagamento.valor)}</b>
      </header>
      {dados.length
        ? <dl>{dados.map(([rotulo, valor]) => <div key={rotulo}><dt>{rotulo}</dt><dd>{valor}</dd></div>)}</dl>
        : <p>{pagamento.origem === 'cabecalho'
          ? 'Forma informada no cabeçalho do pedido. O JSON não traz NSU nem outros dados da transação.'
          : 'Sem NSU ou outros dados de transação neste pagamento.'}</p>}
    </article>
  );
}

export default function PagamentoDetalhes({ pedido }) {
  if (!pedido.pagamentos.length) {
    return (
      <div className="pay-details pay-details-empty">
        <strong>Nenhum pagamento registrado neste pedido</strong>
        <span>O JSON enviado pelo aplicativo não informou a forma de pagamento nem no bloco de pagamento, nem no cabeçalho.</span>
      </div>
    );
  }

  return (
    <div className="pay-details">
      <div className="pay-cards">
        {pedido.pagamentos.map(pagamento => <CartaoPagamento key={pagamento.id} pagamento={pagamento} />)}
      </div>
      <footer className="pay-totals">
        <span>Total do pedido <strong>{moeda.format(pedido.total)}</strong></span>
        {pedido.acrescimos > 0 && <span>Inclui acréscimos de <strong>{moeda.format(pedido.acrescimos)}</strong></span>}
        <span>Total pago <strong>{moeda.format(pedido.total_pago)}</strong></span>
        {pedido.diferenca !== 0 && <span>Diferença <strong>{pedido.diferenca > 0 ? '+' : ''}{moeda.format(pedido.diferenca)}</strong></span>}
        <SituacaoBadge situacao={pedido.situacao} />
      </footer>
    </div>
  );
}
